import { useEffect } from 'react';
import isNativeMobile from '@/utils/platform/isNativeMobile';

const STYLE_ID = 'disable-text-selection';

/**
 * Injects a global <style> tag that disables long-press text selection
 * on native mobile apps (iOS/Android). Preserves selection in inputs/textareas.
 * Must be called after SDK context is initialized.
 */
const useDisableTextSelection = () => {
  useEffect(() => {
    if (!isNativeMobile()) return;
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      *, *::before, *::after {
        -webkit-user-select: none;
        user-select: none;
        -webkit-touch-callout: none;
      }
      input, textarea {
        -webkit-user-select: auto;
        user-select: auto;
        -webkit-touch-callout: auto;
      }
    `;
    document.head.appendChild(style);

    return () => {
      style.remove();
    };
  }, []);
};

export default useDisableTextSelection;
